import { MakePurchaseResult, PurchasesPackage } from '@revenuecat/purchases-capacitor';

import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { revenueCatService } from '../../../application/RevenueCatService';

type UseRetrieveUserCredentialsResponseProps = ServiceResponse<
  (packageToPurchase: PurchasesPackage) => void,
  MakePurchaseResult | null
>;

export const useSubscribeToPackage = (): UseRetrieveUserCredentialsResponseProps => {
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [data, setData] = useState<MakePurchaseResult | null>(null);

  const purchasePackage = async (packageToPurchase: PurchasesPackage): Promise<void> => {
    console.info(`purchasePackage - packageToPurchase:`, packageToPurchase);

    setIsLoading(true);
    setError(false);
    setSuccess(false);

    try {
      const purchaseResult = await revenueCatService.purchasePackage(packageToPurchase);
      console.info(`purchaseResult`, purchaseResult);
      setData(purchaseResult);
      // TODO: REVISAR QUE EFECTIVAMENT S'HAGI SUSCRIT AL PACKAGE QUE VOLIA
      // if (typeof purchaseResult.customerInfo.entitlements.active[`my_entitlement_identifier`] !== `undefined`) {
      //   // Unlock that great "pro" content
      //   setData(purchaseResult);
      // }
      await queryClient.invalidateQueries([`driver_credentials`]);
      setSuccess(true);
    } catch (error) {
      if (error === `PURCHASE_CANCELLED`) {
        // PURCHASE_CANCELLED
        console.error(`PURCHASE CANCELLED`);
      } else {
        // PURCHASE_UNKNOWN_ERROR
        console.error(`ERROR MAKING PURCHASE:`, error);
      }
      setError(true);
    }
    setIsLoading(false);
  };

  console.info(`useSubscribeToPackage data`, data);

  return {
    run: purchasePackage,
    isLoading,
    success,
    error,
    data,
  };
};
